import React from "react";

const ReleaseV2 = () => {
  return (
    <>
      {" "}
      <div className="release_content">
        <h3>Beta v1.0.0</h3>
        <p>Released on 6 June 2023</p>
        <h2>Landing Page Features</h2>
        <hr />
        <ul>
          <li>
            {" "}
            <span>
              Introduced 1 new section Data Products which shows the Power BI
              Dashboard Information
            </span>
          </li>
          <li>
            {" "}
            <span>Introduced EDA Section</span>
          </li>
        </ul>
        <h2>Individual Products Page</h2>
        <hr />
        <ul>
          <li>
            {" "}
            <span>All the Details of Data Products will show here</span>
          </li>
          <li>
            {" "}
            <span>
              The Details Tab shows the owner,tags,tool information,Power BI
              Report Link,where as the Lineage Tab majorly focuses on the
              datasets associated with the report and shown in a tree view,The
              nodes are clickable and navigates to the individual datasets page.
            </span>
          </li>
        </ul>

        <h2>Individual Dataset Page</h2>
        <hr />
        <ul>
          <li>
            {" "}
            <span>
              {" "}
              We have removed read only mode & introduced editable actions to
              some of the columns in the Column Tab i.e Description,Security
              Classification & Sensitivity
            </span>
          </li>
          <li>
            <span>User is now eligible to edit the specified columns</span>
          </li>
          <li>
            <span>
              Certified Datasets tag is introduced where icon is shown next to
              the Dataset where on hover shows the Certified By{" "}
            </span>
          </li>
        </ul>
        <h2>Global Search</h2>
        <hr />
        <ul>
          <li>
            {" "}
            <span>
              On Search,Certified logo will appear next to the datasets searched
            </span>
          </li>
        </ul>
        <h2>View All Datasets Page</h2>
        <hr />
        <ul>
          <li>
            {" "}
            <span>
              Certified Logo is also introduced in this page with certified icon
              next to the dataset
            </span>
          </li>
        </ul>

        <h2>View All Data Products Page</h2>
        <hr />
        <ul>
          <li>
            {" "}
            <span>
              View All Products with all the necessary information inside Button
              and a tooltip for the meaning{" "}
            </span>
          </li>
          <li>
            <span>
              On clicking on any Products will now navigate to the Power BI
              dashboard
            </span>
          </li>
        </ul>
      </div>
    </>
  );
};

export default ReleaseV2;
